import React, {useState, useEffect} from "react";
import {axiosInstance} from "../../config/http";
import {get} from "lodash";
import {useNavigate, useSearchParams} from "react-router-dom";
import {LeftLogoPane, Logos, PageWrapper, RightFormPane} from "./styled";
import iriLogo from "../../assets/IRI_logo.jpg";
import columbiaLogo from "../../assets/columbia_logo.png"
import {Button, InputBox} from "../../common/styled";

const Login = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const inviteEmail = searchParams.get("email");
  const isRegisterMode = !!token;

  const [creds, setCreds] = useState({
    username: inviteEmail || '',
    password: ''
  })

  const navigate = useNavigate();
  const [error, setError] = useState('')
  const [tokenError, setTokenError] = useState('')

  useEffect(() => {
    if (token) {
      axiosInstance.get(`/check_invite?token=${token}`)
        .then(resp => {
          if (resp.data.used) {
            setTokenError('An account already exists for this email. Please login below.')
            setCreds(prev => ({...prev, username: ''}))
          } else if (resp.data.invalid) {
            setTokenError('This invite link is invalid. Please contact the admin.')
            setCreds(prev => ({...prev, username: ''}))
          }
        })
        .catch(() => {
          setTokenError('This invite link is invalid. Please contact the admin.')
          setCreds(prev => ({...prev, username: ''}))
        })
    }
  }, [token])

  // Navigation to this page results in logout
  useEffect(() => {
    localStorage.removeItem('auth')
  }, [])


  const login = async () => {
    setError('')
    try {
      const resp = await axiosInstance.post('/token', creds)
      if (get(resp, 'data.token', null)) {
        localStorage.setItem('auth', resp.data.token)
        navigate("/");
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        setError('Invalid email or password')
      } else {
        setError('Something went wrong. Please try again.')
      }
    }
  }

  const register = async () => {
    try {
      await axiosInstance.post('/register', {
        email: creds.username,
        password: creds.password,
        token: token,
      })
      await login()
    } catch (e) {
      console.error("Failed registration: ", e)
    }
  }

  const credsChange = (e, type) => {
    const newCreds = {...creds}
    newCreds[type] = e.target.value
    setCreds(newCreds)
  }

  return (
    <PageWrapper>
      <LeftLogoPane>
        <span>DESDR NOKi</span>
        <span>SURVEY YOUR WAY</span>
        <Logos>
          <img src={iriLogo}/>
          <img src={columbiaLogo}/>
        </Logos>
      </LeftLogoPane>
      <RightFormPane>
        <InputBox placeholder={'Username'} type={'text'} onChange={(e) => credsChange(e, 'username')}
               value={creds.username}/>
        <InputBox placeholder={'Password'} type={'password'} onChange={(e) => credsChange(e, 'password')}
               value={creds.password}/>
        {error && <p style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{error}</p>}
        {tokenError ? (
            <>
              <p style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{tokenError}</p>
              <Button onClick={login}>Login</Button>
            </>
        ) : isRegisterMode ? (
            <Button onClick={register}>Create Account</Button>
        ) : (
            <>
              <Button onClick={login}>Login</Button>
              <p style={{fontSize: '12px', marginTop: '10px'}}>
                  Don't have an account?
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSecg8UB55Ff_xZpMRML1YckEjLLst71rRVTfGYsf3pR6FO-uA/viewform?usp=publish-editor" target="_blank" rel="noreferrer"> Request access</a>
              </p>
              <p style={{fontSize: '12px', marginTop: '5px'}}>
                <a href="/forgot_password">Forgot password?</a>
              </p>
            </>
        )}
        </RightFormPane>
            </PageWrapper>
          )
        }

export default Login;
